import React from "react";
import PageTitleCard from "../../templates/PageTitleCard";
import PageHeading from "../../../templates/PageHeading";
import { teamData } from "./teamData";
import TeamsCard from "./TeamsCard";
import Underline from "../../../../admin/pages/dashboard/Underline";
import "./teams.css";
import { motion } from "motion/react";
import {
  fadeInAnimation,
  textAnimation,
} from "../../../animation/motionAnimation";
import ceoimage from "../../../../assest/images/ceo.png";
import SubHeadingText from "../../../common/SubHeadingText";
import BackHome from "../../../templates/BackHome";
import RightArrow from "../../../templates/RightArrow";
import CurrentPath from "../../../templates/CurrentPath";
import useGetData from "../../../../hooks/apihooks/useGetData";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const Teams = () => {
  const { data, isLoading, isError } = useGetData("team", "getAllteam");

  return (
    <div>
      <PageTitleCard>
        <PageHeading>Teams</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>Teams</CurrentPath>
        </div>
      </PageTitleCard>
      <div className="container mx-auto py-8 max-sm:px-8">
        <SubHeadingText>
          Our <br /> Amazing <br /> Team
        </SubHeadingText>
        <div className="flex lg:flex-row md:flex-col-reverse sm:flex-col-reverse max-sm:flex-col-reverse justify-between my-4 bg-slate-50 py-8 p-10">
          <div className="w-2/3 lg:w-2/3 md:w-full sm:w-full max-sm:w-full max-sm:py-8 flex flex-col justify-center">
            <h2 className="text-4xl font-semibold py-0.5">
              Suseendhar Seethapathy
            </h2>
            <p className="py-0.5 font-semibold">CEO & Founder</p>
            {/* <p className="py-0.5 pr-4">
              We are committed to achieving CO₂ neutrality by 2035, pioneering a
              sustainable future in forging. Our focus is on creating
              significant value, delivering unparalleled experiences, and
              leading the industry toward a greener, more responsible future.
            </p> */}
          </div>
          <div className="w-1/3 lg:w-1/3 md:w-full sm:w-full max-sm:w-full">
            <div className="teams-imgbox min-w-60 max-w-80 h-80">
              <img
                src={ceoimage}
                className="min-w-60 max-w-80 h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-4 lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 max-sm:grid-cols-1 gap-4">
          {isLoading
            ? Array.from({ length: 8 }).map((_, i) => (
                <Skeleton
                  className="w-60 h-60 object-cover rounded-full"
                  key={i}
                />
              ))
            : data?.map((v, i) => {
                return (
                  <TeamsCard
                    key={i}
                    name={v?.name}
                    role={v?.role}
                    index={i}
                    image={v?.image_url}
                  />
                );
              })}
        </div>
      </div>
    </div>
  );
};

export default Teams;
